/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';
import Container from '@mui/material/Container';
import { SxProps } from '@mui/material';
import DefaultFooter from '../Default/DefaultFooter';
import { fadeInSx } from 'framework/ui/styles';

const PublicLayout = ({
  children = '',
  header,
  sx = {},
}: {
  children?: React.ReactNode;
  header?: React.ReactNode;
  sx?: SxProps;
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', main: { flexGrow: 1 } }}>
    <main className="main">
      {header && header}
      <Container sx={{ ...fadeInSx, ...sx }}>{children}</Container>
    </main>
    <DefaultFooter />
  </Box>
);

export default PublicLayout;
